const STORAGE_KEY = 'paymeo_negotiations';

export const saveNegotiationSession = ({ user_id, negotiation_id, product_slug, negotiation_status }) => {
    try {
        const sessions = loadAllNegotiationSessions();
        const existingIndex = sessions.findIndex(s => s.product_slug === product_slug);
        const entry = {
            user_id: user_id || null,
            negotiation_id,
            product_slug,
            negotiation_status,
            updated_at: Date.now()
        };
        if (existingIndex > -1) {
            sessions[existingIndex] = { ...sessions[existingIndex], ...entry };
        } else {
            sessions.push(entry);
        }
        sessionStorage.setItem(STORAGE_KEY, JSON.stringify(sessions));
    } catch (e) {
        console.error('Error saving negotiation session:', e);
    }
};

export const getNegotiationByProductSlug = (productSlug) => {
    try {
        const sessions = loadAllNegotiationSessions();
        return sessions.find(s => s.product_slug === productSlug) || null;
    } catch (e) {
        console.error('Error getting negotiation session:', e);
        return null;
    }
};

export const loadAllNegotiationSessions = () => {
    try {
        const raw = sessionStorage.getItem(STORAGE_KEY);
        return raw ? JSON.parse(raw) : [];
    } catch (e) {
        console.error('Error loading negotiation sessions:', e);
        return [];
    }
};

export const removeNegotiationSession = (productSlug) => {
    try {
        const sessions = loadAllNegotiationSessions();
        const filtered = sessions.filter(s => s.product_slug !== productSlug);
        sessionStorage.setItem(STORAGE_KEY, JSON.stringify(filtered));
    } catch (e) {
        console.error('Error removing negotiation session:', e);
    }
};

export const clearAllNegotiationSessions = () => {
    try {
        sessionStorage.removeItem(STORAGE_KEY);
    } catch (e) {
        console.error('Error clearing negotiation sessions:', e);
    }
};
